import { Typography } from 'src/components/PulseUI';
import React from 'react';
import { ActivityIcon } from 'src/components/Activity';

interface ActivitySelectOption {
  item: MedScout.ActivityType;
}

const ActivitySelectOption = ({ item }: ActivitySelectOption) => {
  return (
    <div className="flex items-center gap-2 w-full">
      {item?.value && (
        <ActivityIcon
          item={item}
          height="24px"
          width="24px"
          iconSize="0.75rem"
        />
      )}
      <Typography variant="body2" color="tertiary" className="leading-[1.243rem]">
        {item?.label}
      </Typography>
    </div>
  );
};

export default ActivitySelectOption;
